/**
 * @generated SignedSource<<3fdd5d403533b46442d17ed7baa75599>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FeedPostAttachmentType = "CAROUSEL" | "LINK" | "MEDIA" | "NONE" | "POLL" | "%future added value";
export type FeedPostFormQuery$variables = {
  brandID: string;
  id: string;
  skip: boolean;
};
export type FeedPostFormQuery$data = {
  readonly brand: {
    readonly " $fragmentSpreads": FragmentRefs<"FeedPostForm_brand">;
  };
  readonly feedPost?: {
    readonly id: string;
    readonly type: FeedPostAttachmentType;
    readonly " $fragmentSpreads": FragmentRefs<"FeedCarouselForm_feedPost" | "FeedPollForm_feedPost" | "FeedSinglePostForm_feedPost">;
  };
};
export type FeedPostFormQuery = {
  response: FeedPostFormQuery$data;
  variables: FeedPostFormQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "brandID"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skip"
},
v3 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v6 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "brandID"
  }
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "subtitle",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "coverImageUrl",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "concreteType": "GraphQLMedia",
  "kind": "LinkedField",
  "name": "media",
  "plural": false,
  "selections": [
    (v9/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "FeedPostFormQuery",
    "selections": [
      {
        "condition": "skip",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "GraphQLFeedPost",
            "kind": "LinkedField",
            "name": "feedPost",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "FeedSinglePostForm_feedPost"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "FeedPollForm_feedPost"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "FeedCarouselForm_feedPost"
              }
            ],
            "storageKey": null
          }
        ]
      },
      {
        "alias": null,
        "args": (v6/*: any*/),
        "concreteType": "BrandType",
        "kind": "LinkedField",
        "name": "brand",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "FeedPostForm_brand"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "FeedPostFormQuery",
    "selections": [
      {
        "condition": "skip",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "GraphQLFeedPost",
            "kind": "LinkedField",
            "name": "feedPost",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "GraphQLCDPAudience",
                "kind": "LinkedField",
                "name": "audiences",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "audienceId",
                    "storageKey": null
                  },
                  (v4/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "audienceLanguages",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "publishedAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "GraphQLLink",
                "kind": "LinkedField",
                "name": "link",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "externalMediaUrl",
                    "storageKey": null
                  },
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "GraphQLMedia",
                    "kind": "LinkedField",
                    "name": "media",
                    "plural": true,
                    "selections": [
                      (v9/*: any*/),
                      (v10/*: any*/),
                      (v5/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v4/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "GraphQLNotification",
                "kind": "LinkedField",
                "name": "notification",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "body",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "utmCampaign",
                    "storageKey": null
                  },
                  (v4/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "GraphQLPoll",
                "kind": "LinkedField",
                "name": "poll",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v8/*: any*/),
                  (v11/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "customResponsesEnabled",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "GraphQLPollOption",
                    "kind": "LinkedField",
                    "name": "pollOptions",
                    "plural": true,
                    "selections": [
                      (v4/*: any*/),
                      (v8/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isCustomerCreatedOption",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isStatic",
                        "storageKey": null
                      },
                      (v11/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "GraphQLCarousel",
                "kind": "LinkedField",
                "name": "carousel",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v8/*: any*/),
                  (v7/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "GraphQLCarouselItem",
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": true,
                    "selections": [
                      (v4/*: any*/),
                      (v8/*: any*/),
                      (v7/*: any*/),
                      (v9/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "GraphQLMedia",
                        "kind": "LinkedField",
                        "name": "media",
                        "plural": false,
                        "selections": [
                          (v9/*: any*/),
                          (v5/*: any*/),
                          (v10/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ]
      },
      {
        "alias": null,
        "args": (v6/*: any*/),
        "concreteType": "BrandType",
        "kind": "LinkedField",
        "name": "brand",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "GraphQLFeed",
            "kind": "LinkedField",
            "name": "feed",
            "plural": false,
            "selections": [
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "GraphQLCDP",
            "kind": "LinkedField",
            "name": "cdps",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cdpType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "GraphQLCDPAudienceType",
                "kind": "LinkedField",
                "name": "audiences",
                "plural": true,
                "selections": [
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  (v5/*: any*/)
                ],
                "storageKey": null
              },
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "BrandAppConfigType",
            "kind": "LinkedField",
            "name": "appConfig",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "supportedLanguages",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "enableLanguageSpecificContent",
                "storageKey": null
              },
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b53b566ef677f32fb65eb69640f89929",
    "id": null,
    "metadata": {},
    "name": "FeedPostFormQuery",
    "operationKind": "query",
    "text": "query FeedPostFormQuery(\n  $id: ID!\n  $skip: Boolean!\n  $brandID: ID!\n) {\n  feedPost(id: $id) @skip(if: $skip) {\n    id\n    type\n    ...FeedSinglePostForm_feedPost\n    ...FeedPollForm_feedPost\n    ...FeedCarouselForm_feedPost\n  }\n  brand(id: $brandID) {\n    ...FeedPostForm_brand\n    id\n  }\n}\n\nfragment CDPAudienceLanguageSelector_brand on BrandType {\n  ...useBrandLanguages_brand\n}\n\nfragment CDPAudienceSelectorCard_brand on BrandType {\n  ...CDPAudienceSelector_brand\n  ...CDPAudienceLanguageSelector_brand\n}\n\nfragment CDPAudienceSelector_brand on BrandType {\n  ...useBrandAudiences_brand\n}\n\nfragment FeedCarouselForm_brand on BrandType {\n  id\n  feed {\n    id\n  }\n  ...useFeedPostCreateMutation_brand\n  ...useFeedPostUpdateMutation_brand\n  ...CDPAudienceSelectorCard_brand\n}\n\nfragment FeedCarouselForm_feedPost on GraphQLFeedPost {\n  id\n  audiences {\n    audienceId\n    id\n  }\n  audienceLanguages\n  publishedAt\n  notification {\n    title\n    body\n    utmCampaign\n    id\n  }\n  carousel {\n    id\n    title\n    subtitle\n    items {\n      id\n      title\n      subtitle\n      url\n      media {\n        url\n        type\n        coverImageUrl\n      }\n    }\n  }\n}\n\nfragment FeedPollForm_brand on BrandType {\n  id\n  feed {\n    id\n  }\n  ...useFeedPostCreateMutation_brand\n  ...useFeedPostUpdateMutation_brand\n  ...CDPAudienceSelectorCard_brand\n}\n\nfragment FeedPollForm_feedPost on GraphQLFeedPost {\n  id\n  audiences {\n    audienceId\n    id\n  }\n  audienceLanguages\n  publishedAt\n  notification {\n    title\n    body\n    utmCampaign\n    id\n  }\n  poll {\n    id\n    title\n    media {\n      url\n    }\n    customResponsesEnabled\n    pollOptions {\n      id\n      title\n      isCustomerCreatedOption\n      isStatic\n      media {\n        url\n      }\n    }\n  }\n}\n\nfragment FeedPostForm_brand on BrandType {\n  ...FeedSinglePostForm_brand\n  ...FeedPollForm_brand\n  ...FeedCarouselForm_brand\n}\n\nfragment FeedSinglePostForm_brand on BrandType {\n  id\n  feed {\n    id\n  }\n  ...useFeedPostCreateMutation_brand\n  ...useFeedPostUpdateMutation_brand\n  ...CDPAudienceSelectorCard_brand\n}\n\nfragment FeedSinglePostForm_feedPost on GraphQLFeedPost {\n  id\n  audiences {\n    audienceId\n    id\n  }\n  audienceLanguages\n  publishedAt\n  link {\n    externalMediaUrl\n    subtitle\n    title\n    url\n    media {\n      url\n      coverImageUrl\n      type\n    }\n    id\n  }\n  notification {\n    title\n    body\n    utmCampaign\n    id\n  }\n}\n\nfragment useBrandAudiences_brand on BrandType {\n  cdps {\n    cdpType\n    audiences {\n      id\n      name\n      type\n    }\n    id\n  }\n}\n\nfragment useBrandLanguages_brand on BrandType {\n  appConfig {\n    supportedLanguages\n    enableLanguageSpecificContent\n    id\n  }\n}\n\nfragment useFeedPostCreateMutation_brand on BrandType {\n  id\n}\n\nfragment useFeedPostUpdateMutation_brand on BrandType {\n  id\n}\n"
  }
};
})();

(node as any).hash = "fd6e799d9aa7cbe992edb625a6aab02d";

export default node;
